import type { EditorEdge } from '../../domain/editor-graph';
import type { ConnectionCandidate } from './validate-connection';
import type { EdgeTypeId } from '@/domain/funnel/edge-system';
import { getEdgeDefinition } from '../registry/edge-registry';

/**
 * SPEC-006 EDGE-REQ-006/T018 — a valid connection creates an edge with a
 * unique id, `type = standard` and default style.
 */
export function createEdgeFromCandidate(
  candidate: ConnectionCandidate,
  type: EdgeTypeId = 'standard',
  createId: () => string = () => crypto.randomUUID(),
): EditorEdge {
  const definition = getEdgeDefinition(type);
  return {
    id: createId(),
    source: candidate.source,
    target: candidate.target,
    ...(candidate.sourceHandle ? { sourceHandle: candidate.sourceHandle } : {}),
    ...(candidate.targetHandle ? { targetHandle: candidate.targetHandle } : {}),
    type,
    data: { ...(definition?.defaultData ?? { style: 'solid', animated: false }) },
  };
}
